 
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export enum ActiveModal {
  SALES_COMPANY_CODE = 'salesCompanyCode',
}

type LayoutProps = {
  isOpen: boolean,
  showCookieBanner: boolean,
  cookiesAccepted: boolean,
  activeModal: ActiveModal | null,
};

export const defaultState: LayoutProps = {
  isOpen: false,
  showCookieBanner: true,
  cookiesAccepted: localStorage.getItem('userCookiesConsent')
    ? JSON.parse(localStorage.getItem('userCookiesConsent')!).acceptedCookies
    : false,
  activeModal: null,
};

const slice = createSlice({
  name: 'layout',
  initialState: defaultState,
  reducers: {
    setIsOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    setCookiesAccepted: (state, action: PayloadAction<boolean>) => {
      state.cookiesAccepted = action.payload;
    },
    setShowCookieBanner: (state, action: PayloadAction<boolean>) => {
      state.showCookieBanner = action.payload;
    },
    setActiveModal: (state, action: PayloadAction<ActiveModal | null>) => {
      state.activeModal = action.payload;
    }
  },
});

export const {
  setIsOpen,
  setCookiesAccepted,
  setShowCookieBanner,
  setActiveModal,
} = slice.actions;
export default slice.reducer;
